export const roleInfo = {
  admin: "管理者",
  member: "メンバー",
  user: "ユーザー",
};

export const getRoleName = (roleNo: number) => {
  switch (roleNo) {
    case 1:
      return roleInfo.admin;
    case 2:
      return roleInfo.member;
    case 3:
      return roleInfo.user;
    default:
      return "";
  }
};
